import { useTranslation } from 'next-i18next'

import { Breakpoint, useCheckBreakpoint } from '~/utils'

import { CurriculumCountryCodes } from '../constants/curriculum.const'

import CurriculumDropdown from './CurriculumDropdown'
import MenuCurriculumMobileDropdown from './MenuCurriculumMobileDropdown'

interface Props {
  handleOptionSelect: (chosenCurriculumName: string) => void
  currentCurriculum: string
  currentCurriculumCode: string
  unsetStateLabel?: string
  theme?: 'light' | 'dark'
}

export default function MenuCurriculumDropdown({
  handleOptionSelect,
  currentCurriculum,
  currentCurriculumCode,
  unsetStateLabel,
  theme = 'light',
}: Props): React.ReactElement {
  const { t } = useTranslation('curriculum')
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })
  const isDark = theme === 'dark'
  const displayCurriculum = currentCurriculum || t('selectCurriculum')
  const displayCurriculumCode = currentCurriculumCode || CurriculumCountryCodes.DEFAULT
  if (isMobile) {
    return (
      <MenuCurriculumMobileDropdown
        currentCurriculum={displayCurriculum}
        currentCurriculumCode={displayCurriculumCode}
        handleOptionSelect={handleOptionSelect}
        theme={theme}
        unsetStateLabel={unsetStateLabel}
      />
    )
  }
  return (
    <div className={`flex flex-col items-center space-y-1 font-medium tracking-px ${isDark ? '' : 'pt-3'}`}>
      <span className={isDark ? 'text-xs uppercase text-white' : 'text-3 text-black -ml-2'}>{t('dropdownTitle')}</span>
      <CurriculumDropdown
        allowOverflow
        currentCurriculum={displayCurriculum}
        currentCurriculumCode={displayCurriculumCode}
        handleOptionSelect={handleOptionSelect}
        isForMenu
        theme={theme}
        unsetStateLabel={unsetStateLabel}
      />
    </div>
  )
}
